import { StaffAttendanceService } from '../staff-attendance.service';
import { Component, OnInit, ViewChild, ViewEncapsulation, Inject } from '@angular/core';
import { FloatingMenuOption } from '../../../../../../src/app/common/components/master-floating-menu/model/master-floating-model';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SnackBarService } from '../../../../../../src/app/common/components/snackbar/snackbar.service';
import { SnackBarData } from '../../../../../../src/app/common/components/snackbar/model/snackbar.model';
import { ColumnFilter, RequestData, SearchSort } from '../../../../../../src/app/common/models/request-data.model';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { ConfirmDialogComponent, ConfirmDialogModel } from '../../../../../../src/app/common/components/confirm-dialog/confirm-dialog.component';
import { SelectionModel } from '@angular/cdk/collections';
import { FilterListItemModel, SearchFilterComponent, SearchParam } from '../../../../../../src/app/common/components/search-filter/search-filter.component';
import { Router } from '@angular/router';
import { StateManagerService } from '../../../../../../src/app/common/services/state.manager.service';
import { MatSort, SortDirection } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { staffAttendanceModel } from './model/staffAttendanceModel.model';
import { EmployeeService } from 'src/app/pages/common/employees/employee/employee.service';
import { WeeklyCashAndBankingReportService } from '../../reports/weekly-cash-and-banking-report/weekly-cash-and-banking-report.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { CommonModule } from '@angular/common';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { EmployeeBrowseDialogComponent } from './employee-browse-dialog/employee-browse-dialog.component';
import { PermissionService } from 'src/app/auth/permission.service';


@Component({
  selector: 'app-staff-attendance',
  standalone: false,
  templateUrl: './staff-attendance.component.html',
  styleUrl: './staff-attendance.component.scss',
  // Add required modules for template and dialog
  
})
export class StaffAttendanceComponent implements OnInit {
  // staffAttendanceList: any[] = [];
  // loading = false;
  // error: string | null = null;

  // constructor(private staffAttendanceService: StaffAttendanceService) {}

  // ngOnInit() {
  //   this.loading = true;
  //   const requestData = {"search":{"filters":{"simpleSearch":[],"advSearch":[],"scope":{"limit":50,"offset":0}},"sort":[{"column":"f_name","order":"asc"}]}}
  //   this.staffAttendanceService.getList(requestData).subscribe({
  //     next: (data) => {
  //       this.staffAttendanceList = data;
  //       this.loading = false;
  //     },
  //     error: (err) => {
  //       this.error = 'Failed to load staff attendance data';
  //       this.loading = false;
  //     }
  //   });
  // }
    editForm: FormGroup;
    currentYear: number;
    requestData: any = null;
    // years: number[];
    selectedYear: any;
    weeks: any[] = [];
    terminalListData: any = [];
    financialYears: any[] = []; // This will store the finYears array from API
    years: number[] = []; // This will store just the year numbers if needed separately
    isExpandedTerminal = false;
    curFinYear!: string;
    showThisLastOption: boolean = false;

  staffAttendanceList: staffAttendanceModel[] = [];
    
      showSearch: boolean = false;
      isLoading = true;
      filter: FilterListItemModel[] = [
       
        
        {
          title: "Name",
          column: "f_name",
        },
         {
          title: "Terminal",
          column: "s.code",
        },
        {
          title: "is_finalized",
          column: "u.name",
        },
        
      ];
      displayedColumns: string[] = [
        'sl', 'employee_name', 'station_code', 'shift_start_date', 'shift_start_time', 'act_shift_start_time', 'shift_end_date','shift_end_time', 'act_shift_end_time',
         'is_finalized_by', 'delete'
      ];
      // displayedColumns = ['code', 'name', 'description','action'];
      
      pagingData = { length: 0, pageSize: 50, pageIndex: 0 };
      menuOption: FloatingMenuOption = {
        add: true,
        search: false,
        export: true,
        more: true
      }
    
      isHandset: boolean = false;
      searchColumFilter: SearchParam = {};
      columnSortData: SearchSort[] = [];
      selectedItem?: staffAttendanceModel;
      showSummaryPanel: boolean = false;
      selection = new SelectionModel<staffAttendanceModel>(true, []);
      dataSource = new MatTableDataSource(this.staffAttendanceList);
      IsDownloading: boolean=false;

      // Dropdown properties
        employeeList: any[] = [];
      filteredEmployeeList: any[] = []; // For autocomplete
      selectedEmployee: any = '';
      weekList = [
        { value: 'this_last', label: 'This week & Last week' },
        { value: 'this', label: 'This week' },
        { value: 'last', label: 'Last week' }
      ];
      selectedWeek: string = 'this_last';
  currentWeek: any;
  lastWeek: any;
  permission: any;
  
    
     constructor(private breakpointObserver: BreakpointObserver,
       private builder: FormBuilder,
      private staffAttendanceService: StaffAttendanceService,
      private employeeService: EmployeeService,
      
      public dialog: MatDialog,
      private snackBarService: SnackBarService,
      private router: Router,  private stateManagerService: StateManagerService,
       private datePipe: DatePipe,
        private permissionService: PermissionService
    ) {
      this.editForm = this.builder.group({
        // year: this.builder.control( ''),
        year: this.builder.control(null),
        week_no: this.builder.control([]), // <-- ensure this is an array
        description: this.builder.control([]),
        decimal_places: this.builder.control([]),
        sort_by: this.builder.control('shop_name'),
        sort_order: this.builder.control('asc'),
        excludeSales: this.builder.control(0),
        excludeExpense: this.builder.control(0),
        terminalFilterAll: [''],
        terminalFilterSelected: [''],
        employee: this.builder.control({ value: [], disabled: true }), // <-- default to array for multi-select
      });
    this.currentYear = new Date().getFullYear();
 this.permission = this.permissionService.getPagePermission('staff_attendance');
      this.staffAttendanceList = [];
    }
    // ...existing code...
loadYearData(): void {
  let requestData = this.buildyearRequestData();
  this.staffAttendanceService.getWeekNoList(requestData).subscribe(response => {
    if (response.status === 'SUCCESS') {
      this.financialYears = response.data.finYears;
      this.years = this.financialYears.map(fy => fy.year);
      this.curFinYear = response.data.curFinYear;
      const currentYearValue = parseInt(this.curFinYear.split('-')[0]);

      this.financialYears = response.data.finYears.filter((fy: any) =>
        fy.year <= currentYearValue
      );
      this.years = this.financialYears.map(fy => fy.year);

      if (!this.editForm.get('year')?.value) {
        const currentFinYear = this.financialYears.find(fy => fy.year === currentYearValue);

        if (currentFinYear) {
          this.editForm.get('year')?.setValue(currentYearValue, { emitEvent: false });

          let weeksArray = currentFinYear.weeks;
          this.currentWeek = this.getCurrentWeek(weeksArray);
          console.log("Current Week:", this.currentWeek);

          if (this.currentWeek) {
            weeksArray = weeksArray.filter((week: any) => week.week_no <= this.currentWeek.week_no);
          }
          this.lastWeek = this.weeks.find(w => w.week_no === this.currentWeek.week_no - 1);

          // Sort weeks in descending order
          weeksArray = weeksArray.sort((a: any, b: any) => b.week_no - a.week_no);

          this.weeks = weeksArray.map((week: any) => ({
            ...week,
            displayText: `${this.padWeekNumber(week.week_no)} (${this.datePipe.transform(week.start_date, 'dd-MM-yyyy')} - ${this.datePipe.transform(week.end_date, 'dd-MM-yyyy')})`
          }));

          // Only show and select "This week & Last week" if current year is selected
          this.showThisLastOption = true;
          this.editForm.get('week_no')?.setValue(['this_last'], { emitEvent: false });
          this.loadPreviousState();
        }
      }
    }
  });
}

formatTime(time: string): string {
  if (!time) return '';

  // Expecting time as "HH:mm:ss"
  const parts = time.split(':');
  if (parts.length < 2) return time;

  return `${parts[0]}:${parts[1]}`; // return HH:mm (no seconds)
}

     /**
       * initilaize the device model
       */
     ngOnInit(): void {
      this.breakpointObserver.observe([Breakpoints.Handset]).subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.isHandset = true;
        } else {
          this.isHandset = false;
        }

       
        
      });
      // Remove this.loadData(); from here, let loadYearData call it after defaults are set

      // TODO: Load employeeList from API if needed
      this.loadEmployeeData();
      this.loadYearData();

      // Autocomplete: filter employees as user types
      this.editForm.get('employee')?.valueChanges.subscribe(value => {
        this.filterEmployees();
        // Optionally, reload data on employee change
        // this.loadData();
      });

      // Optionally, reload data when form values change
      this.editForm.valueChanges.subscribe(() => {
        // this.loadData();
      });
    }
     /** 
      * Set the datasource
      */
     setDataSource(staffAttendanceList: staffAttendanceModel[]) {
      this.staffAttendanceList = staffAttendanceList; // <-- Add this line
      this.dataSource = new MatTableDataSource(staffAttendanceList);
      this.dataSource.sort = this.sort;
    }
    @ViewChild(MatSort) sort!: MatSort;
    @ViewChild('searchFilter') searchFilter!: SearchFilterComponent;
    ngAfterViewInit(): void {
    
      // this.loadPreviousState();
      // this.loadData();
    }
    
    /**
     * loads the previous state if exists
     */
    loadPreviousState(): void {
      const previousState = this.stateManagerService.getState(this.constructor.name);

      if (previousState !== undefined && previousState.state && previousState.state.search) {
        // Restore paging
        if (previousState.state.search.filters.scope) {
          this.pagingData.pageIndex = previousState.state.search.filters.scope.offset / previousState.state.search.filters.scope.limit;
          this.pagingData.pageSize = previousState.state.search.filters.scope.limit;
        }

        // Restore sort
        if (previousState.state.search.sort && previousState.state.search.sort.length > 0) {
          this.setSortColumn(
            previousState.state.search.sort[0].column,
            previousState.state.search.sort[0].order
          );
        } else {
          this.setSortColumn('f_name', 'asc');
        }

        // Restore advanced search filters to form controls if present
        const advSearch = previousState.state.search.filters.advSearch || [];
        // Restore year
        const yearFilter = advSearch.find((f: any) => f.column === 'year');
        if (yearFilter) {
          this.editForm.get('year')?.setValue(yearFilter.value, { emitEvent: false });
        }
        // Restore employee
        const empFilter = advSearch.find((f: any) => f.column === 'e.id' || f.column === 'employee_id');
        if (empFilter) {
          this.editForm.get('employee')?.setValue(empFilter.value, { emitEvent: false });
        }

        // --- Fix: Restore week_no selection robustly ---
        // If previousState.state.weeks exists, restore as array of week objects or "this_last"
        if (previousState.state.weeks && previousState.state.weeks.length > 0) {
          const weeksFromState = previousState.state.weeks;
          let weekValue: any = [];

          // Try to match "this_last" if both current and last week are present
          if (
            weeksFromState.length === 2 &&
            this.currentWeek && this.lastWeek &&
            weeksFromState.some((w: any) => w.week_no === this.currentWeek.week_no && w.year === this.currentWeek.year) &&
            weeksFromState.some((w: any) => w.week_no === this.lastWeek.week_no && w.year === this.lastWeek.year)
          ) {
            weekValue = ['this_last'];
          } else {
            // Try to map week objects from state to current weeks list
            weekValue = weeksFromState.map((w: any) => {
              // Find matching week object in this.weeks
              const found = this.weeks.find(
                (wk: any) => wk.week_no === w.week_no && wk.year === w.year
              );
              return found || w;
            });
          }
          this.editForm.get('week_no')?.setValue(weekValue, { emitEvent: false });
        }

        // Restore search filter UI
        this.searchColumFilter = JSON.parse(JSON.stringify(previousState.state.search.filters));
        if (this.searchFilter) {
          this.searchFilter.setSearchFilter(this.searchColumFilter, true);
        }

        // Finally, load data with restored state
        this.loadData();
      } else {
        this.setSortColumn('f_name', 'asc');
        // this.loadData();
      }
    
    }
      /**
       * Sets the sort column
       * @param column 
       * @param direction 
       */
      setSortColumn(column: string, direction: SortDirection): void {
        this.columnSortData.length = 0;
        this.columnSortData.push({ column: column, order: direction});
        this.sort.sort({
          id: column,
          start: direction,
          disableClear: false,
        });
    
        // this.sort.active=column;
        // this.sort.direction=direction;
        
    
      }
    
    
      isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.staffAttendanceList.length;
        return numSelected === numRows;
      }
    
      toggleAllRows() {
        if (this.isAllSelected()) {
          this.selection.clear();
          return;
        }
    
        this.selection.select(...this.staffAttendanceList);
      }
    
      /**
       * Create sort order
       * @returns sort criteria
       */
      getSort(): SearchSort[] {
        return this.columnSortData;
      }
    
    /**
       * Builds the request data to be send to API
       * @returns Request Data
       */
   
  buildRequestData(): any {
    let searchParam = this.getSearchParam();

    const selectedEmployee = this.editForm.get('employee')?.value;
    const selectedYear = this.editForm.get('year')?.value;
    let selectedWeekNo = this.editForm.get('week_no')?.value;

    let advSearch = [...(searchParam.advSearch || [])];

    // ------------ EMPLOYEE LOGIC (unchanged) -------------
    if (selectedEmployee && Array.isArray(selectedEmployee) && selectedEmployee.length > 0) {
      const ids = selectedEmployee
        .map((emp: any) => typeof emp === 'object' ? emp.id : emp)
        .filter((id: any) => !!id);

      if (ids.length > 0) {
        advSearch.push({ column: 'e.id', value: ids, operator: 'in' });
      }
    } else if (selectedEmployee) {
      let empId = typeof selectedEmployee === 'object' ? selectedEmployee.id : selectedEmployee;
      if (empId) {
        advSearch.push({ column: 'e.id', value: empId, operator: '=' });
      }
    }

    // ---------------------------------------------------------
    // WEEK LOGIC
    // ---------------------------------------------------------
    let weeks: any[] = [];

    // Multi-select week dropdown logic
    if (Array.isArray(selectedWeekNo)) {
      selectedWeekNo.forEach((w: any) => {
        if (typeof w === 'object' && w.week_no) {
          weeks.push({
            year: w.year,
            week_no: w.week_no,
            start_date: w.start_date,
            end_date: w.end_date
          });
        } else if (w === 'this_last') {
          if (this.currentWeek) weeks.push({ ...this.currentWeek });
          if (this.lastWeek) weeks.push({ ...this.lastWeek });
        }
      });
    }

    // Single week object
    else if (selectedWeekNo && typeof selectedWeekNo === 'object' && selectedWeekNo.week_no) {
      weeks.push({
        year: selectedWeekNo.year,
        week_no: selectedWeekNo.week_no,
        start_date: selectedWeekNo.start_date,
        end_date: selectedWeekNo.end_date
      });
    }

    // Single "this_last"
    else if (selectedWeekNo === 'this_last') {
      if (this.currentWeek) weeks.push({ ...this.currentWeek });
      if (this.lastWeek) weeks.push({ ...this.lastWeek });
    }

    // ---------------------------------------------------------
    // ⭐ FINAL RULE — NEVER SEND EMPTY WEEKS
    // ---------------------------------------------------------
    if (weeks.length === 0) {
      if (this.currentWeek) weeks.push({ ...this.currentWeek });
      if (this.lastWeek) weeks.push({ ...this.lastWeek });
    }

    // ---------------------------------------------------------

    let requestData: any = {
      search: {
        filters: {
          simpleSearch: searchParam.freeSearch,
          advSearch: advSearch,
          scope: {
            limit: this.pagingData.pageSize,
            offset: (this.pagingData.pageIndex * this.pagingData.pageSize),
          }
        },
        sort: this.getSort(),
      },
      weeks: weeks   // <-- never empty
    };

    return requestData;
}

// ...existing code...
     /**
       * Set the column filter and reaload the daaa
       * @param columFilter 
       */
    
     onFilterApplied(columFilter: any): void {
      this.searchColumFilter = columFilter;
      this.loadData();
    
    }
    
     /**
       * On delete menu item selected
       * Confirm the action and call the api to update
       */
     
    
    /**
     * loads the data based on the conditions
     */
    loadData(): void {
      this.isLoading = true;
      let requestData = this.buildRequestData();
      let response = this.staffAttendanceService.getList(requestData).subscribe(response => {
        if (response.status == 'SUCCESS') {
          this.setDataSource(response.data.staffAttendance);
          console.log(response.data.staffAttendance);
          this.pagingData.length = response.data.total_count;
          if (this.pagingData.length == 0) {
            let snackBarData: SnackBarData = {
              message: 'No data found. Please remove or change the filter if any.',
              title: 'No Data!!!',
              type: 'warn'
            }
            this.snackBarService.openSnackBar(snackBarData);
            this.selectedItem = undefined;
          } else {
            this.onRowSelected(this.staffAttendanceList[0])
            this.stateManagerService.setState(this.constructor.name, requestData);
          }
        } else {
          let snackBarData: SnackBarData = {
            message: response.message,
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
        this.isLoading = false;
      });
    
    }
    
     /**
     * On kitcheninfo selected
     * @param staffAttendanceInfo 
     */
     onRowSelected(staffAttendanceInfo: staffAttendanceModel): void {
      this.selectedItem = staffAttendanceInfo;
      this.showSummaryPanel = true;
    }
    
     /**
       *  Set the sort param and relead the data
       * @param $event sort data
       * {"active": "email","direction": "asc"}
       *   
       */
     sortData($event: any): void {
      var sd=this.sort;
      this.columnSortData.length = 0;
      this.columnSortData.push({ column: sd.active, order: sd.direction });
      this.loadData();
    }
      /**
    * Creates the column filter conditions based on search criteria
    * @returns Filter condions for columns
    */
    getSearchParam(): SearchParam {
    
      return this.searchColumFilter;
    }
    
      /**
     * On edit the item
     * Show the edit dialog
     */
      onEdit(staffAttendanceInfo: staffAttendanceModel): void {
    
        this.router.navigate(['staff-attendance-edit', staffAttendanceInfo.id]);
      }
    
      
      /**
       * 
       * @param event 
       * When page size is changed update paging data
       */
      onePageEvent(event: any): void {
    
        this.pagingData.pageIndex = event.pageIndex;
        this.pagingData.pageSize = event.pageSize;
    
        this.loadData();
    
      }
    
      /**
       * On Add clicked
       * Show the dialog to enter new area
       */
      addClicked(): void {

        this.router.navigate(['staff-attendance-edit', 0]);

      }
    
      onEmployeeChange(event: any) {
        // Handle employee selection change
        // You may want to reload data based on selectedEmployee
        // this.loadData();
      }
    
      // onYearChange(event: any) {
      //   // Handle year selection change
      //   this.loadData();
      // }
    
      onWeekChange(event: any) {
        // Handle week selection change
        // this.loadData();
      }
    
      // exportClicked() {
      //   this.isLoading = true;
      //   let requestData = this.buildRequestData();
      //   this.IsDownloading = true;
      //   this.kitchenService.downloadExcel(requestData)
      //     .subscribe({
      //       next: blob => {
      //         // Download logic
      //         this.IsDownloading = false;
      //         const url = window.URL.createObjectURL(blob);
      //         const link = document.createElement('a');
      //         link.href = url;
      //         link.download = 'region_list.csv'; // Adjust filename if needed
      //         link.click();
      //         window.URL.revokeObjectURL(url);
      //         this.isLoading = false;
    
    
      //       },
      //       error: error => {
      //         // Handle errors
      //         this.IsDownloading = false;
      //         let snackBarData: SnackBarData = {
      //           message: 'Failed to update. Connection to the server failed',
      //           title: 'Failed!!!',
      //           type: 'error'
      //         }
      //         this.snackBarService.openSnackBar(snackBarData);
      //         this.isLoading = false;
      //         // Display user-friendly error message to the user
      //       }
      //     }
      //     );
      // }








       loadEmployeeData(): void {
    this.isLoading = true;
    let requestData = {
  search: {
    filters: {
      simpleSearch: [],
      advSearch: [
        { column: "status", operator: "=", value: 1 }
      ],
      scope: {
        limit: 1000,
        offset: 0
      }
    },
    sort: [
      {
        column: "l_name",
        order: "asc"
      }
    ]
  }
};

    let response = this.employeeService.getEmployeeList(requestData).subscribe(response => {
      if (response.status == 'SUCCESS') {
        // Only include employees with status === 1 (active)
        this.employeeList = response.data.employees
          .filter((emp: any) => emp.status === 1)
          .sort((a: any, b: any) => {
            const nameA = `${a.f_name || ''} ${a.m_name || ''} ${a.l_name || ''}`.trim().toLowerCase();
            const nameB = `${b.f_name || ''} ${b.m_name || ''} ${b.l_name || ''}`.trim().toLowerCase();
            return nameA.localeCompare(nameB);
          });
        this.filteredEmployeeList = this.employeeList.slice(); // Initialize filtered list
        console.log(this.employeeList);
        this.pagingData.length = response.data.total_count;
        if (this.pagingData.length == 0) {
          let snackBarData: SnackBarData = {
            message: 'No data found. Please remove or change the filter if any.',
            title: 'No Data!!!',
            type: 'warn'
          }
          this.snackBarService.openSnackBar(snackBarData);
          this.selectedItem = undefined;
        } else {
        
        }
      } else {
        let snackBarData: SnackBarData = {
          message: response.message,
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
      this.isLoading = false;
    });
  
  }

  filterEmployees() {
    const value = this.editForm.get('employee')?.value;
    if (!value || value.length === 0) {
      this.filteredEmployeeList = this.employeeList.slice();
      return;
    }
    // If value is array, filter by any name match
    let filterValue = '';
    if (Array.isArray(value) && value.length > 0) {
      // Use the last selected value for filtering
      const last = value[value.length - 1];
      filterValue = typeof last === 'object'
        ? `${last.f_name} ${last.m_name} ${last.l_name}`.toLowerCase()
        : last.toLowerCase();
    } else if (typeof value === 'string') {
      filterValue = value.toLowerCase();
    }
    this.filteredEmployeeList = this.employeeList.filter((emp: any) =>
      (`${emp.f_name} ${emp.m_name} ${emp.l_name}`.toLowerCase().includes(filterValue))
    );
  }

  displayEmployee(emp: any): string {
    // Not used in mat-select multi, but keep for compatibility
    if (Array.isArray(emp)) {
      return emp.map(e => e && e.f_name ? `${e.f_name} ${e.m_name || ''} ${e.l_name || ''}`.replace(/\s+/g, ' ').trim() : '').join(', ');
    }
    return emp && emp.f_name ? `${emp.f_name} ${emp.m_name || ''} ${emp.l_name || ''}`.replace(/\s+/g, ' ').trim() : '';
  }

  clearEmployee() {
    this.editForm.get('employee')?.setValue([]);
    this.filteredEmployeeList = this.employeeList.slice();
  }

  getCurrentWeek(weeks: any[]): any {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return weeks.find(week => {
      const startDate = new Date(week.start_date);
      const endDate = new Date(week.end_date);
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);

      return today >= startDate && today <= endDate;
    });
  }

  buildyearRequestData(): any {
    return {
      search: {
        filters: {
          simpleSearch: [],
          advSearch: [],
          scope: {
            limit: "100",
            offset: "0"
          }
        },
        sort: [
          {
            column: "wd.year",
            order: "desc"
          }
        ]
      }
    };
  }

 
onYearChange(): void {
  const selectedYear = this.editForm.get('year')?.value;
  const currentYearValue = parseInt(this.curFinYear.split('-')[0]);
  const selectedFinYear = this.financialYears.find(fy => fy.year === selectedYear);

  if (selectedFinYear) {
    let weeksArray = selectedFinYear.weeks;
    const isCurrentYear = selectedYear === currentYearValue;

    if (isCurrentYear) {
      if (this.currentWeek) {
        weeksArray = weeksArray.filter((week: any) => week.week_no <= this.currentWeek.week_no);
      }
    }

    // Sort weeks in descending order
    weeksArray = weeksArray.sort((a: any, b: any) => b.week_no - a.week_no);

    this.weeks = weeksArray.map((week: any) => ({
      ...week,
      displayText: `${this.padWeekNumber(week.week_no)} (${this.datePipe.transform(week.start_date, 'dd-MM-yyyy')} - ${this.datePipe.transform(week.end_date, 'dd-MM-yyyy')})`
    }));

    // Only show and select "This week & Last week" if current year is selected
    this.showThisLastOption = isCurrentYear;
    if (isCurrentYear) {
      this.editForm.get('week_no')?.setValue(['this_last']);
    } else {
      this.editForm.get('week_no')?.setValue([]);
    }
  } else {
    this.weeks = [];
    this.editForm.get('week_no')?.setValue(null);
    this.showThisLastOption = false;
  }
}
// ...existing code...
  padWeekNumber(weekNo: number): string {
    return weekNo.toString().padStart(2, '0');
  }



  // Add this method to open the dialog
  openEmployeeBrowseDialog(): void {
    const dialogRef = this.dialog.open(EmployeeBrowseDialogComponent, {
      width: '400px',
      data: {
        employees: this.employeeList,
        selected: this.editForm.get('employee')?.value // pass array of selected employees
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // result is now an array of selected employees
        this.editForm.get('employee')?.setValue(result);
      }
    });
  }

  // Add this method for template badge
  getSelectedEmployeeCount(): number {
    const value = this.editForm.get('employee')?.value;
    if (Array.isArray(value)) {
      return value.length;
    }
    return value ? 1 : 0;
  }


  

  onDelete(staffAttendanceinfo: staffAttendanceModel): void {
      // const areaId = kitchenInfo.id;
      const message = `Are you sure, you want to delete ` + (staffAttendanceinfo.employee_name + " " + staffAttendanceinfo.employee_lname + "?");
      const dialogData = new ConfirmDialogModel("Confirm Deletion", message);
    
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        maxWidth: "500px",
        data: dialogData
      });
    
      dialogRef.afterClosed().subscribe(dialogResult => {
        console.log(dialogResult);
        if (dialogResult) {
          this.staffAttendanceService.delete(staffAttendanceinfo).subscribe({
            next: (response) => {
              if (response.status == 'SUCCESS') {
                // handle success
                let snackBarData: SnackBarData = {
                  type: 'success',
                  title: 'Saved',
                  message: 'The record for ' + staffAttendanceinfo.employee_name + " " + staffAttendanceinfo.employee_lname + " has been deleted succesfully."
                }
                this.snackBarService.openSnackBar(snackBarData);
                this.loadData();
              } else {
                let snackBarData: SnackBarData = {
                  message: response.message,
                  title: 'Failed!!!',
                  type: 'error'
                }
                this.snackBarService.openSnackBar(snackBarData);
              }
            },
            error: (error) => {
              let snackBarData: SnackBarData = {
                message: 'Failed to update. Connection to the server failed',
                title: 'Failed!!!',
                type: 'error'
              }
              this.snackBarService.openSnackBar(snackBarData);
            }
          });
        }
      });
    }

 onFinalized(staffAttendanceinfo: staffAttendanceModel): void {
      // const areaId = kitchenInfo.id;
      const message = `Are you sure, you want to finalize ` + (staffAttendanceinfo.employee_name + " " + staffAttendanceinfo.employee_lname + "?");
      const dialogData = new ConfirmDialogModel("Confirm Finalization", message);

      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        maxWidth: "500px",
        data: dialogData
      });
    
      dialogRef.afterClosed().subscribe(dialogResult => {
        console.log(dialogResult);
        if (dialogResult) {
          this.staffAttendanceService.finalize(staffAttendanceinfo).subscribe({
            next: (response) => {
              if (response.status == 'SUCCESS') {
                // handle success
                let snackBarData: SnackBarData = {
                  type: 'success',
                  title: 'Saved',
                  message: 'The record for ' + staffAttendanceinfo.employee_name + " " + staffAttendanceinfo.employee_lname + " has been deleted succesfully."
                }
                this.snackBarService.openSnackBar(snackBarData);
                this.loadData();
              } else {
                let snackBarData: SnackBarData = {
                  message: response.message,
                  title: 'Failed!!!',
                  type: 'error'
                }
                this.snackBarService.openSnackBar(snackBarData);
              }
            },
            error: (error) => {
              let snackBarData: SnackBarData = {
                message: 'Failed to update. Connection to the server failed',
                title: 'Failed!!!',
                type: 'error'
              }
              this.snackBarService.openSnackBar(snackBarData);
            }
          });
        }
      });
    }

     exportClicked() {
      this.isLoading = true;
      let requestData = this.buildRequestData();
      this.IsDownloading = true;
      this.staffAttendanceService.downloadExcel(requestData)
        .subscribe({
          next: blob => {
            // Download logic
            this.IsDownloading = false;
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = 'Weekly_sales_list.xlsx'; // Adjust filename if needed
            link.click();
            window.URL.revokeObjectURL(url);
            this.isLoading = false;
  
  
          },
          error: error => {
            // Handle errors
            this.IsDownloading = false;
            let snackBarData: SnackBarData = {
              message: 'Failed to update. Connection to the server failed',
              title: 'Failed!!!',
              type: 'error'
            }
            this.snackBarService.openSnackBar(snackBarData);
            this.isLoading = false;
            // Display user-friendly error message to the user
          }
        }
        );
    }
}


